import { Component, OnInit, Input } from '@angular/core';
import { FormElementComponent } from '../form-element/form-element.component';

@Component({
    selector: 'app-number-input',
    templateUrl: './number-input.component.html',
    styleUrls: ['./number-input.component.scss'],
})
export class NumberInputComponent extends FormElementComponent implements OnInit {
    @Input() minValue!: number;
    @Input() maxValue!: number;
    @Input() money!: boolean;
    @Input() warnIcon!: string;
    @Input() warnToolTip!: string;
    @Input() spinner = false;
    @Input() inputBgColor: string | null = null;
    @Input() inputTextColor: string | null = null;

    constructor() {
        super();
    }

    getError() {
        const control = this.form.get(this.name);
        if (control && control.errors) {
            return this.objectValues(control.errors)[0];
        }
        return null;
    }
}
